import parse from 'node-html-parser';

import { replaceRelLink } from './seo/content/replaceRelLink';

export const generateContentFromHtml = (htmlBody: string): { content: string; withSOWidget: boolean } => {
  const markup = parse(htmlBody);

  replaceRelLink(markup);

  const SOVerticalWidgetWrapper = markup.querySelector('[data-special-offers]');

  return {
    content: markup.toString(),
    withSOWidget: !!SOVerticalWidgetWrapper,
  };
};
